import React, { useMemo } from 'react';
import SegmentedPolylineOverlay from './SegmentedPolylineOverlay';

const sensitivityColorMap = {
    1: '#1976d2', // blue
    2: '#fbc02d', // yellow
    3: '#f57c00', // orange
    4: '#7b1fa2', // purple
    5: '#00897b', // teal
    6: '#c2185b', // pink
    7: '#455a64', // gray
    8: '#afb42b', // lime
    9: '#00FF00', // green
};

// Per-value descriptions for legend items
const gpsQualityDescriptions = {
    1: "GNSS Only",
    2: "Differential Correction",
    3: "PPS Fix",
    4: "RTK Correction",
    5: "RTK Float",
    6: "Dead Reckoning",
    7: "Manual Mode",
    8: "Simulation Mode",
    9: "SBAS Fix"
};

function getRange(allPoints, uniqueGpsQualityValues) {
    return uniqueGpsQualityValues.map(val => {
        const value = val.toString();
        return {
            min: value,
            max: value,
            color: sensitivityColorMap[value],
            value,
            description: gpsQualityDescriptions[value] || "Unknown quality",
        };
    });
}

export default function GpsQualityOverlay({ routes }) {
    const allPoints = useMemo(() => routes.flat(), [routes]);
    const uniqueGpsQualityValues = useMemo(() => {
        const set = new Set();
        allPoints.forEach(pt => {
            if (
                pt.gpsQuality !== undefined &&
                pt.gpsQuality !== null &&
                pt.gpsQuality !== '' &&
                !isNaN(Number(pt.gpsQuality))
            ) {
                set.add(Number(pt.gpsQuality));
            }
        });
        return Array.from(set).sort((a, b) => a - b);
    }, [allPoints]);

    const finalRanges = useMemo(
        () => getRange(allPoints, uniqueGpsQualityValues),
        [allPoints, uniqueGpsQualityValues]
    );

    const valueSelector = pt => pt.gpsQuality;

    // Legend formatter for string values
    const legendFormatter = r => `${r.value} - ${r.description}`;

    return (
        <SegmentedPolylineOverlay
            segments={routes}
            valueSelector={valueSelector}
            ranges={finalRanges}
            legendTitle="Gps Quality"
            legendFormatter={legendFormatter}
            units=""
            discrete={true}
        />
    );
}